import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function SquadSystem() { 
  useEffect(() => {
    document.title = 'Squad System-  CARMEL CONVENT SCHOOL, DHARUHERA';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li> 
                <li>Squad System</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Squad System</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
                  <p> The entire school community is divided into four Squads.  The Squad system aims to give the students an identity and a sense of pride in a supportive and secure environment.  It also encourages healthy competition and promotes achievements of the students in a positive manner. </p>
                  <div className="Squadbox">
                     <div className="Squadboxdiv"> <p>   SATYA <br/> (TRUTH) </p>	 </div> 
                     <div className="Squadboxdiv"> <p>  EKTA <br/>(UNITY) </p></div>
                     <div className="Squadboxdiv"> <p>  NAMRATA	 <br/>   (HUMILITY) </p> </div>
                     <div className="Squadboxdiv"> <p>  NIRMAL <br/>  (PURITY)</p> </div>
                  </div>
             </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default SquadSystem;
